import { EnvironmentVariable, getEnvVar } from '@lib/config';

export const getSiteUrl = () => {
  return getEnvVar(EnvironmentVariable.siteUrl) || window.location.origin;
};
